import { getImage } from '../../../../utils/imageHelper';
import styles from '../../cards.module.scss';

function JobOfferItem({ joboffer, handleClickJobOffer, layout }) {
  return (
    <div className={`${styles.projectCard} `} onClick={handleClickJobOffer}>
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{joboffer.title}</p>
          <p className={styles.subtitle}>{joboffer.company}</p>
          <p className={styles.subtitle}>{joboffer?.city?.city}</p>
        </div>
      </div>
    </div>
  );
}

export default JobOfferItem;
